import React, { useMemo } from "react";
import { Global, css } from "@emotion/react";
import { useWebAssets } from "../hooks/useWebAssets";
const UntitledSansWebLight = "untitled-sans/untitled-sans-web-light.woff2";
const UntitledSansWebReg = "untitled-sans/untitled-sans-web-regular.woff2";
const UntitledSansWebMedium = "untitled-sans/untitled-sans-web-medium.woff2";
const UntitledSansWebBold = "untitled-sans/untitled-sans-web-bold.woff2";
const UntitledSansWebBlack = "untitled-sans/untitled-sans-web-black.woff2";
const UntitledSerifWebReg = "untitled-serif/untitled-serif-web-regular.woff2";
const UntitledSerifWebMed = "untitled-serif/untitled-serif-web-medium.woff2";
const UntitledSerifWebBold = "untitled-serif/untitled-serif-web-bold.woff2";
const BrownLLThin = "brown-ll/brown-ll-web-thin.woff2";
const BrownLLLight = "brown-ll/brown-ll-web-light.woff2";
const BrownLLMedium = "brown-ll/brown-ll-web-medium.woff2";
const BrownLLRegular = "brown-ll/brown-ll-web-regular.woff2";
const BrownLLBold = "brown-ll/brown-ll-web-bold.woff2";
const generateFF = (fontFamily, path, { format = "woff2", weight, } = {}) => `
  @font-face {
    font-family: "${fontFamily}";
    src: url("${path}") format("${format}");
    font-style: normal;

    ${!weight ? "" : `font-weight: ${weight};`}
  }`;
const fonts = [
    ["Untitled Sans", UntitledSansWebLight, { weight: 300 }],
    ["Untitled Sans", UntitledSansWebReg, { weight: 400 }],
    ["Untitled Sans", UntitledSansWebMedium, { weight: 500 }],
    ["Untitled Sans", UntitledSansWebBold, { weight: 700 }],
    ["Untitled Sans", UntitledSansWebBlack, { weight: 900 }],
    ["Untitled Serif", UntitledSerifWebReg, { weight: 400 }],
    ["Untitled Serif", UntitledSerifWebMed, { weight: 500 }],
    ["Untitled Serif", UntitledSerifWebBold, { weight: 700 }],
    ["Brown LL", BrownLLThin, { weight: 100 }],
    ["Brown LL", BrownLLLight, { weight: 300 }],
    ["Brown LL", BrownLLRegular, { weight: 400 }],
    ["Brown LL", BrownLLMedium, { weight: 500 }],
    ["Brown LL", BrownLLBold, { weight: 700 }],
];
function Fonts() {
    const { createAssetUrl } = useWebAssets();
    const styles = useMemo(() => {
        return css `
      ${fonts.map(([fontFamily, path, { weight }]) => generateFF(fontFamily, createAssetUrl("font", path), { weight }))}
    `;
    }, [createAssetUrl]);
    return React.createElement(Global, { styles: styles });
}
export default Fonts;
//# sourceMappingURL=Fonts.js.map